import { Badge } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { Course } from 'types/data'
import { getSeriesStatus, isSeriesOffLaunch } from '../../utils/seriesStatus'
import classes from './CadenceBadge.module.scss'

interface StaticData {
  course: Course
}

const CadenceBadge = () => {
  const { course } = useStaticData<StaticData>()
  const { t } = useTranslation('@mc/next')

  const seriesStatus = getSeriesStatus(course)

  if (isSeriesOffLaunch(course)) return <></>

  return (
    <div data-testid={`cadence-badge-${seriesStatus}`}>
      <Badge className={classes.cadenceBadge}>
        {t(`series.hero.cadence.${seriesStatus}`)}
      </Badge>
    </div>
  )
}

export default CadenceBadge
